export const updateHash = (hash: string): void =>
  window.history.pushState(null, '', hash);

export const getHash = (): number | undefined => {
  const param = window.location.hash.split('#').pop();
  return param ? Number(param) : undefined;
};
